import React from "react"
import { useStaticQuery, graphql } from "gatsby"

// COPY FROM HERE
// 0. Move header image from original header component to src/images
// 1. Update value of variables above
// 2. Update children of SecondaryNavigation if needed
// 3. Update children of About
import Layout from '../../components/layout'
import About from '../../components/about'
import Speakers from '../../components/speakers'
import Agenda from '../../components/agenda'
import JoinUs from '../../components/joinusbui'
import { SecondaryNavigation } from '../../components/navigation'
import headerImage from '../../images/websiteheader_applications.jpg'

import "../../style/main.scss"

// initialize page data
const pageTitle = 'Building low-code, high-impact business applications with Appian'
const pageNavigation = {
  type: 'horizontal',
  items: [
    {
      title: 'Webinars',
      url: '/',
    },
  ]
}

const headerimageAltText = 'Building low-code, high-impact business applications with Appian'

const eventBriteId = ''
const eventBriteModalTriggerElementId = ''
const eventBriteNoScriptUri = 'https://www.eventbrite.com/e/low-codeno-code-at-the-heart-of-the-mission-registration-170448433854'

const layoutNavigation = ''
const layoutHeaderImage = ''

const aboutDetails = [
  {
    'key': 'Date',
    'value': '10.28.21'
  },
  {
    'key': 'Time',
    'value': '1:00 PM - 2:00 PM ET'
  }
]
const aboutCtaText = 'WATCH NOW »'
const aboutCtaClassNames = 'regworkwatch'
const aboutCtaClassNamesMobile = 'regmobwatch'

const sponsorEventName = 'oct14'
const sponsorPDFUrl = 'https://s3.amazonaws.com/sng-global-web-assets/sponsors/SNGLIVE_SponsorPackageV2.pdf'
const sponsorsClassNames = 'grouplogoshide'


const IndexPage = () => {
  const data = useStaticQuery(graphql`
      query {
        site {
          siteMetadata {
            speakers {
              name
              title
              image
              disabledProfile
              event
            }
            sponsorshipLevel
            sponsors {
              name
              level
              logo
              url
              width
              event
            }
            sessions {
              startTime
              endTime
              title
              description
              type
              speakers {
                name
                isModerator
              }
              event
            }
          }
        }
      }
    `)

  const {
    speakers,
    sessions,
    sponsors,
    sponsorshipLevel
  } = data.site.siteMetadata

  return (
    <Layout
      title={pageTitle}
      eventBriteId={eventBriteId}
      eventBriteModalTriggerElementId={eventBriteModalTriggerElementId}
      eventBriteNoScriptUri={eventBriteNoScriptUri}
      navigation={pageNavigation}
      headerImage={{
        imageUri: headerImage,
        imageMobileUril: headerImage,
        imageAltText: headerimageAltText
      }} >
      <SecondaryNavigation>
        <a className='subNavButton' href='#Speakers'>SPEAKERS</a>
        
        <a className='subNavButtonReg' href="https://www.fedscoop.com/events/deloitte-innovation-in-federal-health/10-28/watch/" >WATCH NOW»</a>
      </SecondaryNavigation>
      <About
        details={aboutDetails}
        ctaText={aboutCtaText}
        ctaId={eventBriteModalTriggerElementId}
        ctaClassNames={aboutCtaClassNames}
        ctaClassNamesMobile={aboutCtaClassNamesMobile}
        ctaUrl="https://www.fedscoop.com/events/deloitte-innovation-in-federal-health/10-28/watch/"
        sponsorPDFUrl={sponsorPDFUrl}
        sponsorEventName={sponsorEventName}
        sponsors={sponsors}
        sponsorsClassNames={sponsorsClassNames}
        sponsorshipLevel={sponsorshipLevel} >
          In our fourth webinar we’ll discuss the Appian low-code development platform and how it enables acceleration of the creation of high-impact business applications.  Join leaders from Deloitte and Appian to discuss real life examples on how the Appian platform orchestrates actions across users, robots, and systems into automated flows empowering organizations to work faster, smarter, better, and focus on what matters most.<br />
          {/*<ul className="bulletList">
            <li>The changing landscape of contact center technology</li>
            <li>Cost efficiencies gained through automation</li>
    </ul>*/}
      </About>
      {speakers && <Speakers speakers={speakers} sponsorEventName={sponsorEventName} />}
      {/*{sessions && <Agenda sessions={sessions} speakers={speakers} sponsorEventName={sponsorEventName} />}*/}
      <JoinUs eventBriteModalTriggerElementId={eventBriteModalTriggerElementId} />
    </Layout>
  )
}

export default IndexPage
// COPY STOPS HERE